export default __webpack_public_path__ + "static/media/PBTC-BNB.8eb4402b.svg";